import '@/styles/dmq-retailer-swiper.scss';
import Swiper from '@/swiper';

export default class DmqRetailerSwiper extends Swiper {
  constructor() {
    super('.dmq-retailer-swiper-container', {
      containerModifierClass: 'dmq-retailer-swiper-container-',
      slideClass: 'dmq-retailer-swiper-slide',
      slideActiveClass: 'dmq-retailer-swiper-slide-active',
      slideDuplicateActiveClass: 'dmq-retailer-swiper-slide-duplicate-active',
      slideVisibleClass: 'dmq-retailer-swiper-slide-visible',
      slideDuplicateClass: 'dmq-retailer-swiper-slide-duplicate',
      slideNextClass: 'dmq-retailer-swiper-slide-next',
      slideDuplicateNextClass: 'dmq-retailer-swiper-slide-duplicate-next',
      slidePrevClass: 'dmq-retailer-swiper-slide-prev',
      slideDuplicatePrevClass: 'dmq-retailer-swiper-slide-duplicate-prev',
      wrapperClass: 'dmq-retailer-swiper-wrapper',
      pagination: {
        el: '.dmq-retailer-swiper-pagination',
        clickable: true,
        bulletClass: 'dmq-retailer-swiper-pagination-bullet',
        bulletActiveClass: 'dmq-retailer-swiper-pagination-bullet-active',
        modifierClass: 'dmq-retailer-swiper-pagination-',
        currentClass: 'dmq-retailer-swiper-pagination-current',
        totalClass: 'dmq-retailer-swiper-pagination-total',
        hiddenClass: 'dmq-retailer-swiper-pagination-hidden',
        progressbarFillClass: 'dmq-retailer-swiper-pagination-progressbar-fill',
        clickableClass: 'dmq-retailer-swiper-pagination-clickable',
      },
    });
  }
}
